import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { DynamicPageBuilderHSeparatorComponent } from './dynamic-page-builder-hseparator.component';
import { MaterialModule } from 'src/app/shared/material.module';
import { PageBuilderHSeparatorComponent } from './page-builder-hseparator.component';

@NgModule({
    declarations: [
        PageBuilderHSeparatorComponent, DynamicPageBuilderHSeparatorComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
    ],
    entryComponents: [
        DynamicPageBuilderHSeparatorComponent
    ]
})
export class PageBuilderHSeparatorModule {}